import {
  GET_MARITALTAX,
  GET_MARITALTAX_SUCCESS,
  GET_MARITALTAX_FAIL,
  DELETE_MARITALTAX,
  DELETE_MARITALTAX_SUCCESS,
  DELETE_MARITALTAX_FAIL,
  UPDATE_MARITALTAX,
  UPDATE_MARITALTAX_SUCCESS,
  UPDATE_MARITALTAX_FAIL,
  ADD_NEW_MARITALTAX,
  ADD_MARITALTAX_SUCCESS,
  ADD_MARITALTAX_FAIL,
  MARITALTAX_LOADING,
  MARITALTAX_RESET,
} from "./actionType";

export const resetMaritalTaxState = (actionType) => ({
  type: MARITALTAX_RESET,
  payload: { actionType },
});

export const getMaritalTaxSuccess = (actionType, data) => ({
  type: GET_MARITALTAX_SUCCESS,
  payload: { actionType, data },
});

export const getMaritalTaxFail = (actionType, error) => ({
  type: GET_MARITALTAX_FAIL,
  payload: { actionType, error },
});

export const getMaritalTax = data => ({
  type: GET_MARITALTAX,
  payload: data,
});

export const getMaritalTaxLoading = () => ({
  type: MARITALTAX_LOADING
});

export const deleteMaritalTax = data => ({
  type: DELETE_MARITALTAX,
  payload: data,
});

export const deleteMaritalTaxSuccess = data => ({
  type: DELETE_MARITALTAX_SUCCESS,
  payload: data,
});

export const deleteMaritalTaxFail = error => ({
  type: DELETE_MARITALTAX_FAIL,
  payload: error,
});

export const updateMaritalTax = data => ({
  type: UPDATE_MARITALTAX,
  payload: data,
});

export const updateMaritalTaxFail = error => ({
  type: UPDATE_MARITALTAX_FAIL,
  payload: error,
});

export const updateMaritalTaxSuccess = data => ({
  type: UPDATE_MARITALTAX_SUCCESS,
  payload: data,
});

export const addNewMaritalTax = data => ({
  type: ADD_NEW_MARITALTAX,
  payload: data,
});

export const addMaritalTaxSuccess = data => ({
  type: ADD_MARITALTAX_SUCCESS,
  payload: data,
});

export const addMaritalTaxFail = error => ({
  type: ADD_MARITALTAX_FAIL,
  payload: error,
});